export const DUAL_NAV_STATES = Object.freeze({
  EXPANDED: 'expanded',
  RESPONSIVE: 'responsive',
  COLLAPSED: 'collapsed',
});
